export default function FavoriteHoverIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_259_8514)">
        <path
          d="M9.31504 1.7791C9.53511 1.33743 9.64515 1.1166 9.79453 1.04604C9.9245 0.984653 10.0755 0.984653 10.2055 1.04604C10.3548 1.1166 10.4649 1.33743 10.685 1.7791L12.7729 5.96929C12.8378 6.09968 12.8703 6.16488 12.9178 6.2155C12.9598 6.26032 13.0102 6.29663 13.0662 6.32242C13.1295 6.35156 13.2021 6.36207 13.3473 6.3831L18.0177 7.05934C18.5095 7.13055 18.7554 7.16616 18.8692 7.28515C18.9682 7.38868 19.0147 7.53095 18.9959 7.67233C18.9742 7.83484 18.7962 8.00661 18.4401 8.35015L15.0619 11.6097C14.9566 11.7113 14.904 11.7621 14.87 11.8225C14.8399 11.8761 14.8206 11.9349 14.8132 11.9957C14.8048 12.0644 14.8172 12.1361 14.842 12.2797L15.6391 16.8836C15.7232 17.3692 15.7653 17.612 15.6863 17.7561C15.6175 17.8814 15.4953 17.9693 15.3538 17.9953C15.191 18.0252 14.9709 17.9106 14.5307 17.6812L10.3555 15.5061C10.2255 15.4384 10.1604 15.4045 10.0919 15.3912C10.0312 15.3794 9.9688 15.3794 9.90812 15.3912C9.8396 15.4045 9.77455 15.4384 9.64446 15.5061L5.46926 17.6812C5.02908 17.9106 4.80899 18.0252 4.64625 17.9953C4.50465 17.9693 4.38248 17.8814 4.31374 17.7561C4.23474 17.612 4.27678 17.3692 4.36085 16.8836L5.15795 12.2797C5.1828 12.1361 5.19523 12.0644 5.18682 11.9957C5.17938 11.9349 5.16008 11.8761 5.12999 11.8225C5.09602 11.7621 5.04336 11.7113 4.93805 11.6097L1.55985 8.35015C1.2038 8.00661 1.02578 7.83484 1.00411 7.67233C0.985265 7.53095 1.03183 7.38868 1.13084 7.28515C1.24464 7.16616 1.49054 7.13055 1.98235 7.05934L6.65266 6.3831C6.7979 6.36207 6.87052 6.35156 6.93377 6.32242C6.98976 6.29663 7.04018 6.26032 7.08221 6.2155C7.12969 6.16488 7.16217 6.09968 7.22714 5.96929L9.31504 1.7791Z"
          stroke="#344054"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_259_8514">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "FavoriteHoverIcon";
